import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { FsMapDrawingServiceProvider } from '@lib/geo/core';
import { SnLonLat } from '@lib/geo/helpers';

import { FsMap } from '../types';

@Injectable()
export class MapDrawingFacadeService extends FsMapDrawingServiceProvider {
  constructor(private readonly provider: FsMapDrawingServiceProvider) {
    super();
  }

  get geospatialProvider(): string {
    return this.provider.geospatialProvider;
  }

  get id(): string {
    return this.provider.id;
  }

  get drawingMode(): string | null {
    return this.provider.drawingMode;
  }

  get newShapeComplete$(): Observable<any> {
    return this.provider.newShapeComplete$;
  }

  get shapeAction(): string | null {
    return this.provider.shapeAction;
  }

  get isDrawingAlertBoundary(): string | null {
    return this.provider.isDrawingAlertBoundary;
  }

  onMapLoaded(fsMap: FsMap): void {
    this.provider.onMapLoaded(fsMap);
  }

  addShape(type: string, action: string): void {
    this.provider.addShape(type, action);
  }

  setDrawingMode(overlayType?: any): void {
    this.provider.setDrawingMode(overlayType);
  }

  getDrawingMode(): any | undefined {
    return this.provider.getDrawingMode();
  }

  resetMapOptions(): void {
    this.provider.resetMapOptions();
  }

  drawPolyline(coordinate1: SnLonLat, coordinate2: SnLonLat): void {
    this.provider.drawPolyline(coordinate1, coordinate2);
  }

  drawPolylines(coordinates: Array<{ position1: SnLonLat; position2: SnLonLat }>): void {
    this.provider.drawPolylines(coordinates);
  }

  clearPolyline(): void {
    this.provider.clearPolyline();
  }

  clearPolylines(): void {
    this.provider.clearPolylines();
  }
  clearDrawing(shape: any): void {
    this.provider.clearDrawing(shape);
  }

  pointInCircle(point: SnLonLat, radius: number, center: SnLonLat): boolean {
    return this.provider.pointInCircle(point, radius, center);
  }

  isPointInShape<T extends { lat: number; lon: number }>(marker: T, shape: any): boolean {
    return this.provider.isPointInShape(marker, shape);
  }

  filterMarkersInShape<T extends { lat: number; lon: number }>(markers: T[], shape: any): T[] {
    return this.provider.filterMarkersInShape(markers, shape);
  }

  removePenListeners(): void {
    this.provider.removePenListeners();
  }

  getDockedElementCoords(element: Element): { lng: number; lat: number } | undefined {
    return this.provider.getDockedElementCoords(element);
  }

  setIsDrawingAlertBoundary(isDrawingAlertBoundary: string | null): void {
    this.provider.setIsDrawingAlertBoundary(isDrawingAlertBoundary);
  }
}
